<template>
  <div class="member-avatars-wrapper">
    <v-menu v-if="isIsPossibleToAddMembers" offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <div v-if="members" class="member-avatars" @click="openMenu">
          <Avatar
            v-for="member in showedMembers"
            :key="member.id"
            :email="member.email"
            :name="member.name"
            :pic="member.files_urls.avatar_thumbnail"
            :size="size"
            class="member-avatar"
          />
          <Avatar
            v-if="members.length > maxCount + 1"
            :name="`+${members.length - maxCount}`"
            class="member-avatar"
            :size="size"
          />
        </div>
        <Button
          v-show="!members.length"
          ref="add-member-btn"
          size="small"
          left-icon="plus"
          type="secondary"
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('Add teammates') }}
        </Button>
      </template>
      <div class="dropdown-body__avatars">
        <MembersSearch
          :members="team"
          :selected-members-ids="selectedIds"
          @select="$emit('select', $event)"
        />
      </div>
    </v-menu>
  </div>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';
  import { VMenu } from 'vuetify/lib';
  import MembersSearch from '@/components/project/tenders/MembersSearch';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'MemberAvatars',
    components: { Avatar, VMenu, MembersSearch, Button },
    props: {
      members: Array,
      size: {
        type: [Number, String],
        default: 24,
      },
      addMembers: {
        type: Boolean,
        default: true,
      },
      team: {
        type: Array,
      },
      maxCount: {
        type: Number,
        default: 3,
      },
    },
    computed: {
      showedMembers() {
        return this.members.length > this.maxCount + 1
          ? this.members.slice(0, this.maxCount)
          : this.members;
      },
      selectedIds() {
        return this.members.map((member) => member.id);
      },
      isIsPossibleToAddMembers() {
        return this.addMembers && this.team;
      },
    },
    methods: {
      openMenu() {
        if (this.isIsPossibleToAddMembers) {
          this.$refs['add-member-btn'].$el.click();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .dropdown-body__avatars {
    background-color: white;
  }

  .member-avatars-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .member-avatars {
      display: flex;
      flex-direction: row;
      cursor: pointer;

      .member-avatar:not(:last-child) {
        margin-right: -10px;
      }

      .member-avatar:last-child {
        margin-right: 0;
      }
    }

    .add-member-btn {
      border: 1px dashed $grey200;
      background-color: inherit;
      outline: none;
      border-radius: 50%;
      margin-left: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        border-color: $grey300;
      }

      ::v-deep svg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 10px;
        width: 10px;
        path {
          fill: $neutral2;
        }
      }
    }
  }
</style>
